module.exports = __webpack_public_path__ + "media/images/google-play-3f67457f372c642beecbb0856c5b9189.png";